import { api } from '../configs/axiosConfigs';
import { ContractTemplateField, TemplateKind } from '../../utility/contractTemplates';
import { unwrapBlobError } from '../../utility/blobErrors';

export const getContractTemplates = async () => api.get('/contract_templates');
export const getContractTemplate = async (id: string) => api.get(`/contract_templates/${id}`);

export const uploadContractTemplate = async (
  input: { name: string; kind: TemplateKind; addendum_tag?: string; pdf: File }, buyerId?: string
) => {
  const form = new FormData();
  form.append('contract_template[name]', input.name);
  form.append('contract_template[kind]', input.kind);
  if (input.addendum_tag) form.append('contract_template[addendum_tag]', input.addendum_tag);
  form.append('contract_template[pdf]', input.pdf);
  if (buyerId) form.append('buyer_id', buyerId);
  return api.post('/contract_templates', form, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const updateContractTemplate = async (id: string, values: { name?: string; kind?: TemplateKind; addendum_tag?: string }) =>
  api.put(`/contract_templates/${id}`, { contract_template: values });

export const deleteContractTemplate = async (id: string) => api.delete(`/contract_templates/${id}`);

export const saveContractTemplateFields = async (id: string, fields: ContractTemplateField[]) =>
  api.put(`/contract_templates/${id}/fields`, { fields });

// Returns the filled sample PDF as a blob so it can be opened in a new tab.
export const previewContractTemplate = async (id: string) => {
  try {
    return await api.post(`/contract_templates/${id}/preview`, null, { responseType: 'blob' });
  } catch (error) {
    // The error message arrives as a blob too; turn it back into JSON so the real message shows.
    throw await unwrapBlobError(error);
  }
};
